// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-banner-2f14","top":"Banner-top-2f14","bottom":"Banner-bottom-2f14","image":"Banner-image-2f14","preview":"Banner-preview-2f14"};